import React from "react";
import axios from "axios";

const SBasic = (parent) => {
	const record = parent.record;
	const code = parent.code

	const isFavorite = record.favor_id !== undefined && record.favor_id !== null;

	// 관심 연구자 추가/삭제 함수
	const handleFavoriteClick = async (record, isFavorite) => {
		const local_user_id = rmVars.scholar_id;
		if(local_user_id) {
			if (isFavorite) {
				// 관심 연구자 삭제
				const confirmDelete = window.confirm("선호 연구자를 삭제하시겠습니까?");
				if (confirmDelete) {
					const url = `scholar_favorite/${local_user_id}/delete`; // DELETE URL
					const options = {
						method: 'GET',
						params: {favor_id: record.favor_id},
						headers: {
							'X-WP-Nonce': rmVars.api_nonce,
						},
						url: rmVars.restApi + url,
					};

					try {
						const response = await axios(options);
						if (response.data.status) {
							console.log("삭제 완료:", response.data.result);
							location.reload();
						}
					} catch (error) {
						console.error("삭제 중 오류 발생:", error);
					}
				}
			} else {
				// 관심 연구자 추가
				const confirmAdd = window.confirm("선호 연구자로 추가하시겠습니까?");
				if (confirmAdd) {
					const url = `scholar_favorite/${local_user_id}/update`; // POST URL
					const options = {
						method: 'GET',
						params: {favor_scholar_id: record.scholar_id},
						headers: {
							'X-WP-Nonce': rmVars.api_nonce,
						},
						url: rmVars.restApi + url,
					};

					try {
						const response = await axios(options);
						if (response.data.status) {
							console.log("추가 완료:", response.data.result);
							location.reload();
						}
					} catch (error) {
						console.error("추가 중 오류 발생:", error);
					}
				}
			}
		} else {
			alert('로그인후 이용해주세요.')
		}
	};

	//console.log(parent)
	// const record = this.props.record;
	//
	return (
		<div>
			<div className="row row-cols-2 ml-n2 mr-n2">
				<div className="col pl-2 pr-2">
					<div className="user-personal-info">
						<div className="user-personal-data">
							<div className="user-picture">
								<div className="thumb"><img src={record.profile_pic ? record.profile_pic : rmVars.themeUrl + '/assets/images/user_picture.png'} alt=""/></div>
								{/*<div className="state-favorite"><span className="icon icon-size-24 icon-favorite-star" /></div>*/}
							</div>
							<div className="user-data">
								<div className="kr-name">{record.scholar_name}
									<span
										className={`icon icon-size-24 ${isFavorite ? 'icon-user-favorite' : 'icon-user-no-favorite'}`}
										onClick={() => handleFavoriteClick(record, isFavorite)} // 클릭 이벤트
										style={{cursor: "pointer", height: "18px"}}
									/>

									{rmVars.isEditor &&
										<a href={rmVars.homeUrl + "?page=scholar&record_id=" + record.scholar_id}
										   target="_blank"
										   className="ml-2"><span className="editor-edit"></span></a>
									}
								</div>
								{/*<div className="en-name">Kendasha Wood</div>*/}
								<div className="cate">{record.sinbun_name} / {record.col_name} {record.dept_name}</div>
							</div>
						</div>
					</div>
				</div>
				<div className="col pl-2 pr-2">
					<div className="user-profile-list">
						{record.research_ids && record.research_ids.map((item, index) => {
							<div className="list-cell"><strong>{item.research_id_type}</strong>
								<div className="txt">{item.research_id}</div>
							</div>
						})}
					</div>
					{Object.keys(code).length > 0 &&
					<div className="user-profile-list">
						<div className="badge-group-inner">
							{record.researcher_id &&
							<a href={code['researcher_id'].map_code + record.researcher_id} className="badge bg-gray link-id link-researcher_id" target="_blank">{record.researcher_id}</a>
							}
							{record.researchgate_id &&
							<a href={code['researchgate_id'].map_code + record.researchgate_id} className="badge bg-gray link-id link-researchgate_id" target="_blank">{record.researchgate_id}</a>
							}
							{record.scopus_id &&
							<a href={code['scopus_id'].map_code + record.scopus_id}
							   className="badge bg-gray link-id link-scopus_id" target="_blank">{record.scopus_id}</a>
							}
							{record.orcid &&
							<a href={code['orcid'].map_code + record.orcid}
							   className="badge bg-gray link-id link-ocr_id" target="_blank">{record.orcid}</a>
							}
							{record.kci_id &&
							<a href={code['kci_id'].map_code + record.kci_id}
							   className="badge bg-gray link-id link-kci_id" target="_blank">{record.kci_id}</a>
							}
							{record.isni &&
							<a href={code['isni'].map_code + record.isni} className="badge bg-gray link-id link-isni" target="_blank">{record.isni}</a>
							}
							{record.googlescholar_id &&
							<a href={code['googlescholar_id'].map_code + record.googlescholar_id} className="badge bg-gray link-id link-googlescholar_id" target="_blank">{record.googlescholar_id}</a>
							}
						</div>
					</div>
					}
					<div className="user-profile-list">

						{record.lab_name &&
						<div className="list-cell"><em>연구실</em>
							<div className="txt">{record.lab_name}</div>
						</div>
						}
						{record.email &&
						<div className="list-cell"><em>이메일</em>
							<div className="txt">{record.email}</div>
						</div>
						}
						{record.homepage &&
						<div className="list-cell"><em>홈페이지</em>
							<div className="txt">{record.homepage}</div>
						</div>
						}
					</div>
				</div>
			</div>
		</div>
	);
};

export default SBasic;
